import { render, staticRenderFns } from "./GroupCreateBlock.vue?vue&type=template&id=111ed2bd&scoped=true"
import script from "./GroupCreateBlock.vue?vue&type=script&lang=js"
export * from "./GroupCreateBlock.vue?vue&type=script&lang=js"
import style0 from "./GroupCreateBlock.vue?vue&type=style&index=0&id=111ed2bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111ed2bd",
  null
  
)

export default component.exports